var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smooth-scrollbar',[_c('div',{staticStyle:{"height":"65vh"}},_vm._l((_vm.orthos),function(group){return _c('group',{key:group.groupID,attrs:{"group":group}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }